<template>
  <div class="table_type">
    <table>
      <caption class="sr-only">{{ $t('Статистика исполнения законов') }}</caption>
      <thead>
        <tr>
          <td  v-if="data[0].transName != null && !acceptedRejectedNorms" role="columnheader">
            {{ $t('Типы законов') }}
          </td>
          <td v-if="data[0].value != null && !acceptedRejectedNorms" role="columnheader">
            {{ $t('Количество законов') }}
          </td>
          <td v-if="data[0].year != null" role="columnheader">
            {{ $t('Год') }}
          </td>
          <td v-if="data[0].normsWithByLawsInYear != null" role="columnheader">
            {{ $t('Кол-во норм, по которым приняты ПА') }}
          </td>
          <td v-if="data[0].normsWithoutByLawsInYear != null" role="columnheader">
            {{ $t('Кол-во норм, по которым не принято ПА')  }}
          </td>
          <td v-if="data[0].percentage != null" role="columnheader">
            {{ $t('Процентное соотношение') }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in data"
          :key="item.id"
        >
          <td
            v-if="item.transName != null && !acceptedRejectedNorms"
          >
            {{ item.transName }}
          </td>
          <td
            class="value"
            v-if="item.value != null && !acceptedRejectedNorms"
          >
            {{ item.value }}
          </td>
          <td v-if="item.year != null">
            <div
              @click="changeYearGraphic(item)"
              @keyup.enter="changeYearGraphic(item)"
              @keyup.space="changeYearGraphic(item)"
              class="year"
              role="button"
              tabindex="0"
              :aria-label="$t('Показать график за год') + ': ' + item.year"
            >
              {{ item.year }}
            </div>
          </td>
          <td v-if="item.normsWithByLawsInYear != null">
            {{ item.normsWithByLawsInYear  }}
          </td>
          <td v-if="item.normsWithoutByLawsInYear != null">
            {{ item.normsWithoutByLawsInYear }}
          </td>
          <td v-if="item.percentage != null">
            {{ item.percentage }}
          </td>
        </tr>
        <tr class="total">
          <td role="rowheader">
            {{ $t('Итого') }}
          </td>
          <td  v-if="data[0].value != null && !acceptedRejectedNorms">
            {{ total.value }}
          </td>
          <td
            v-if="data[0].normsWithByLawsInYear != null"
          >
            {{ total.normsWithByLawsInYear }}
          </td>
          <td
            v-if="data[0].normsWithoutByLawsInYear != null"
          >
            {{ total.normsWithoutByLawsInYear }}
          </td>
          <td
            v-if="data[0].percentage != null"
          >
            {{ total.percentage / 100 }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'LawStatisitcDetailsTypeTable',
  props: {
    data: {
      type: [Array, Object],
      required: true
    },

    acceptedRejectedNorms: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    total () {
      const total = {}

      total.value = this.data.reduce((result, value) => result + value.value, 0)
      total.normsWithByLawsInYear = this.data.reduce((result, value) => result + value.normsWithByLawsInYear, 0)
      total.normsWithoutByLawsInYear = this.data.reduce((result, value) => result + value.normsWithoutByLawsInYear, 0)
      total.percentage = this.data.reduce((result, value) => result + value.percentage, 0)

      return total
    }
  },

  methods: {
    changeYearGraphic (item) {
      this.$emit('change-year-graphic', item)
    }
  }
}
</script>
<style lang="scss" scoped>
  .table_type {
    max-width: 600px;

    tbody tr .value {
      text-align: center;
    }
    thead tr td, .total td{
      text-align: center;
      font-weight: 600;
      background-color: #dddddd;
      text-align: left;
    }
  }

  .year {
    text-decoration: underline;
    cursor: pointer;
  }
</style>
